import { useState } from "react";
import { Checkbox, Dropdown, Grid, Popup } from "semantic-ui-react";
import FilterIcon from "../../../assets/commonIcon/FilterIcon";
import { CustomButton } from "../../../components";
import { productOrderByOptions } from "../../../config/constants";
import { CalculationFilterStatus } from "../../../config/enums/ProductType.enum";
import "./productList.scss";

const ProductFilter = ({ refetchWithFilters }: any) => {
  const [open, setOpen] = useState(false);
  const [calculationStatus, setCalculationStatus] = useState<CalculationFilterStatus>(
    CalculationFilterStatus.NONE
  );
  const [orderBy, setOrderBy] = useState<string>("createdAtDesc");

  const resetValue = () => {
    setCalculationStatus(CalculationFilterStatus.NONE);
    setOrderBy("createdAtDesc");

    localStorage.setItem("calculateStatus", CalculationFilterStatus.NONE);
    localStorage.setItem("productOrderBy", "createdAtDesc");

    refetchWithFilters(CalculationFilterStatus.NONE, "createdAtDesc");
    setOpen(false);
  };

  const filterValue = () => {
    localStorage.setItem("calculateStatus", calculationStatus);
    localStorage.setItem("productOrderBy", orderBy);

    refetchWithFilters(calculationStatus, orderBy);
    setOpen(false);
  };

  return (
    <Popup
      on="click"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      size="large"
      position="bottom left"
      trigger={
        <Grid>
          <CustomButton
            className="filterButton"
            iconWithText
            iconChild={<FilterIcon />}
            buttonOutLine
            theme="green"
            title="Filters"
            iconChildTextCustom={"productCustomBase"}
          />
        </Grid>
      }
    >
      <Grid className="productFilterMainView">
        <Grid.Column>
          <p className="productFilterSortResultTitle">Sort Result</p>
          <Grid className="pt-0">
            <Grid.Column computer={5} tablet={8} mobile={16} className="pt-0">
              <Checkbox
                radio
                label="With calculation"
                checked={calculationStatus === CalculationFilterStatus.CALCULATED}
                onClick={() => setCalculationStatus(CalculationFilterStatus.CALCULATED)}
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={8} mobile={16} className="pt-0">
              <Checkbox
                radio
                label="With out calculation"
                checked={calculationStatus === CalculationFilterStatus.NOT_CALCULATED}
                onClick={() => setCalculationStatus(CalculationFilterStatus.NOT_CALCULATED)}
              />
            </Grid.Column>
            <Grid.Column computer={5} tablet={8} mobile={16} className="pt-0">
              <Checkbox
                radio
                label="Not relevant"
                checked={calculationStatus === CalculationFilterStatus.NONE}
                onClick={() => setCalculationStatus(CalculationFilterStatus.NONE)}
              />
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className="productFilterTitle">Order By</p>
              <Dropdown
                placeholder="Select Order"
                fluid
                selection
                options={productOrderByOptions}
                value={orderBy}
                onChange={(_, { value }) => setOrderBy(value as string)}
              />
            </Grid.Column>
          </Grid>
          <Grid className="pt-0">
            <Grid.Column computer={16} tablet={16} mobile={16} className="productFilterButton">
              <CustomButton
                buttonOutLine
                customBase="productFilterCustomButton"
                theme="green"
                title="Reset"
                onClick={resetValue}
              />
              <CustomButton theme="green" title="Apply" onClick={filterValue} />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Popup>
  );
};

export default ProductFilter;
